<template>
  <div>
    <!-- Overbought -->
    <helpers-section-sub-header class="mt-8 mb-2"> Bollinger Bands </helpers-section-sub-header>
    <p>
      Bollinger bands can identify overbought or oversold conditions. Closing prices above the upper
      band could indicate overbought conditions. Closing prices below the lower band could indicate
      oversold conditions.
    </p>

    <v-data-table :headers="ta_headers" :items="criteria.bollinger_rules" class="mt-6 mb-8">
      <template #top>
        <v-dialog v-model="taDialog" scrollable max-width="450px">
          <template #activator="{ props }">
            <v-btn color="primary" dark class="mb-4" v-bind="props">
              New Bollinger Band Rule
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ taTitle }}</span>
            </v-card-title>

            <v-card-text style="height: 350px">
              <p>
                Bollinger bands can identify overbought or oversold conditions. Closing prices above
                the upper band could indicate overbought conditions. Closing prices below the lower
                band could indicate oversold conditions.
              </p>
              <v-container>
                <v-row density="compact">
                  <v-col cols="12" sm="12">
                    <v-checkbox v-model="editedTa.enabled" density="compact" label="Rule Enabled" />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select
                      v-model="editedTa.long_short"
                      :items="long_short"
                      label="Signal Type"
                      hint="Long or Short Signal"
                      density="compact"
                      hide-details
                      variant="outlined"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select
                      v-model="editedTa.upper_lower"
                      :items="['upper', 'lower']"
                      label="upper or lower band"
                      hint="upper or lower band"
                      density="compact"
                      hide-details
                      variant="outlined"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select
                      v-model="editedTa.ma_days"
                      :items="[
                        2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
                        23, 24, 25, 26, 27, 28, 29, 30
                      ]"
                      label="Moving Avg Days"
                      density="compact"
                      hide-details
                      variant="outlined"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="editedTa.stddev"
                      density="compact"
                      hide-details
                      variant="outlined"
                      label="# Standard Deviations (max 5)"
                    />
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-select
                      v-model="editedTa.above_below"
                      :items="['above', 'below']"
                      label="Current Price Above or Below BBand"
                      hint="Current Price Above or Below BBand"
                      density="compact"
                      hide-details
                      variant="outlined"
                    />
                  </v-col>
                  <v-col v-if="1 == 2" cols="12" sm="12">
                    <v-text-field
                      v-model="editedTa.consecutive_days"
                      density="compact"
                      hide-details
                      variant="outlined"
                      label="Consecutive days price has been above or below"
                    />
                  </v-col>

                  <v-col cols="12" sm="12">
                    <v-text-field
                      v-model="editedTa.percent"
                      density="compact"
                      hide-details
                      variant="outlined"
                      label="% Closing price above or below BBand"
                      hint="Closing Price % Above or Below BBand"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <div class="flex-grow-1" />
              <v-btn color="blue-darken-1" text @click="closeTa"> Cancel </v-btn>
              <v-btn color="blue-darken-1" text @click="saveTa"> Save </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template #item.action="{ item }">
        <v-icon small class="mr-2" @click="editTa(item)"> edit </v-icon>
        <v-icon small @click="deleteTa(item)"> delete </v-icon>
      </template>

      <template #item.enabled="{ item }">
        <v-switch v-model="item.enabled" color="primary" />
      </template>
      <template #no-data> No Bollinger Band signals configured </template>
    </v-data-table>
  </div>
</template>

<script>
// Modules
import { mapFields } from '@/store/helpers'

export default {
  components: {},
  data() {
    return {
      taDialog: false,
      long_short: ['long', 'short'],
      ta_headers: [
        {
          title: 'Enabled',
          align: 'left',
          sortable: true,
          key: 'enabled'
        },
        {
          title: 'Rule Type',
          align: 'left',
          sortable: true,
          key: 'long_short'
        },
        {
          title: 'Above/Below',
          align: 'left',
          sortable: true,
          key: 'above_below'
        },
        {
          title: 'Upper/Lower Band',
          align: 'left',
          sortable: true,
          key: 'upper_lower'
        },
        {
          title: 'Moving Avg',
          align: 'left',
          sortable: true,
          key: 'ma_days'
        },
        {
          title: 'Standard Deviations',
          align: 'left',
          sortable: true,
          key: 'stddev'
        },
        {
          title: '% Change',
          align: 'left',
          sortable: true,
          key: 'percent'
        },
        { title: 'Actions', key: 'action', sortable: false }
      ],
      editedTa: {
        enabled: true,
        above_below: 'below',
        upper_lower: 'lower',
        consecutive_days: 5,
        percent: 3,
        long_short: 'long',
        ma_days: 20,
        stddev: 2
      },
      defaultTa: {
        enabled: true,
        above_below: 'below',
        upper_lower: 'lower',
        consecutive_days: 5,
        percent: 3,
        long_short: 'long',
        ma_days: 20,
        stddev: 2
      },
      editedIndex: -1
    }
  },

  computed: {
    taTitle() {
      return this.editedIndex === -1 ? 'New Rule' : 'Edit Rule'
    },
    ...mapFields({
      appcriteria: 'app.whaleTraderCriteria',
      criteria: 'app.whaleTraderCriteria.signals.trend_signal',
      enabled: 'app.whaleTraderCriteria.signals.trend_signal.enabled',
      signalView: 'app.signalView',
      exit_time_periods: 'app.exit_time_periods'
    })
  },

  watch: {
    taDialog(val) {
      val || this.closeTa()
    }
  },

  created() {},

  methods: {
    editTa(item) {
      this.editedIndex = this.criteria.bollinger_rules.indexOf(item)
      this.editedTa = Object.assign({}, item)
      this.taDialog = true
    },

    deleteTa(item) {
      const index = this.criteria.bollinger_rules.indexOf(item)
      confirm('Are you sure you want to delete this rule?') &&
        this.criteria.bollinger_rules.splice(index, 1)
    },

    closeTa() {
      this.taDialog = false
      setTimeout(() => {
        this.editedTa = Object.assign({}, this.defaultTa)
        this.editedIndex = -1
      }, 300)
    },

    saveTa() {
      if (this.editedIndex > -1) {
        Object.assign(this.criteria.bollinger_rules[this.editedIndex], this.editedTa)
      } else {
        if (!this.criteria.bollinger_rules) {
          this.criteria.bollinger_rules = []
        }
        this.criteria.bollinger_rules.push(this.editedTa)
      }
      this.closeTa()
    }
  }
}
</script>
